import { gql } from '@apollo/client';

export const CONTRACTORS = gql`
  query Contractors($search: String) {
    contractors(search: $search) {
      id
      userId
      name
      phone
      email
      description
      availableArea {
        states
        counties
      }
      createdAt
      updatedAt
      user {
        id
        name
        email
        roles
      }
    }
  }
`;

export const CONTRACTOR = gql`
  query Contractor($id: ID!) {
    contractor(id: $id) {
      id
      userId
      name
      phone
      email
      description
      availableArea {
        states
        counties
      }
      createdAt
      updatedAt
      user {
        id
        name
        email
        roles
      }
    }
  }
`;

export const MY_CONTRACTOR = gql`
  query MyContractor {
    myContractor {
      id
      userId
      name
      phone
      email
      description
      availableArea {
        states
        counties
      }
      createdAt
      updatedAt
    }
  }
`;
